//设备管理
const Management = () => import(/*webpackChunkName:'itil'*/"@/page/itil/equipment/management.vue") //lora地磁
const Station = () => import(/*webpackChunkName:'itil'*/'@/page/itil/equipment/station.vue') //网关
const NbGeomagnetism = () => import(/*webpackChunkName:'itil'*/'@/page/itil/equipment/nbGeomagnetism.vue') //地磁
const EquipWarn = () => import(/*webpackChunkName:'itil'*/'@/page/itil/equipment/equipWarn.vue')
const IntellidataDevice = () => import(/*webpackChunkName:'itil'*/'@/page/itil/equipment/intellidataDevice.vue') //高位视频管理

const RouteTemp = () => import('@/page/commons/routeTemp.vue')

export const deviceManagement = {
    path: '/main/equipment/directive',
    name: '设备管理',
    component: RouteTemp,
    children: [{
            path: '/main/equipment/station',
            name: '网关管理',
            component: Station,
            meta: {
                requireAuth: true,
            },
        }, {
            path: '/main/equipment/management',
            name: 'lora地磁',
            component: Management,
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/main/equipment/intellidataDevice',
            name: '高位视频管理',
            component: IntellidataDevice,
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/main/equipment/nbGeomagnetism',
            name: 'NB地磁',
            component: NbGeomagnetism,
            meta: {
                requireAuth: true,
            },

        },

        {
            path: '/main/equipment/equipWarn',
            name: '报警管理',
            component: EquipWarn,
            meta: {
                requireAuth: true,
            },
        }
    ]
}